import { ReactComponent as BoatIcon } from 'images/object-boat.svg';
import BaseTransportObject from './BaseTransportObject';

export default class Boat extends BaseTransportObject {
  constructor({ basePlace, vesselName, engineCount, vesselClass, grossCapacity, ...config }) {
    super(config);

    this.icon = BoatIcon;
    this.iconClass = 'icon_board';

    Object.assign(this, {
      basePlace,
      engineCount,
      vesselClass,
      vesselName,
      grossCapacity,
    });

    Object.assign(this.propertyTitles, {
      useTerm: 'Срок полезного использования',
      vin: 'Идентификационный номер',
      basePlace: 'Место базирования',
      horsepower: 'Мощность двигателей (л.с.)',
      engineCount: 'Количество двигателей',
      vesselName: 'Наименование судна',
      vesselClass: 'Класс судна (водный)',
      grossCapacity: 'Валовая вместимость (водный)',
    });
  }

  static typeTitle = 'Водный транспорт';

  getTypeTitle() {
    return Boat.typeTitle;
  }

  getTitle() {
    return this.title || `${this.vesselName || ''} ${this.registrationSign || ''}`;
  }

  getName() {
    return `${this.vesselName || ''} ${this.registrationSign || ''}`;
  }

  getPdfTitle() {
    return `${super.getPdfTitle()}, ${this.vesselName}`;
  }

  isBoat() {
    return true;
  }
}
